<!-- =========================================================================================
    File Name: Documenti.vue
    Description: Documenti - Visualizzazione a tabella di tutti i documenti vari
========================================================================================== -->

<template>
    <div id="table-altri">
        <table-altri></table-altri>
    </div>
</template>

<script>

import TableAltri from './TableAltri.vue'

export default{
    components: {
        TableAltri,
    }
}
</script>
